import { BigNumber } from "../external/bignumber.js/bignumber.js";
import { BN_ZERO } from "../constants/index.js";
const EN_GROUP_SEPARATOR = ",";
const EN_DECIMAL_SEPARATOR = ".";
function fNumber(number, options) {
  const { abbreviate = false, abbreviateThreshold = 1e6, decimals: defaultDecimals = 0 } = options || {};
  let suffix = "";
  if (typeof number === "string" && number === "-") return number;
  let decimals = defaultDecimals;
  let bNumber = bnOrZero(number);
  if (abbreviate && bNumber.gte(abbreviateThreshold)) {
    bNumber = bNumber.integerValue(BigNumber.ROUND_DOWN);
    bNumber = bNumber.div(1e3).integerValue(BigNumber.ROUND_DOWN);
    suffix = " K";
    decimals = 0;
  }
  const { groupSeparator, decimalSeparator } = getSeparators();
  const fmt = {
    groupSeparator,
    decimalSeparator,
    groupSize: 3
  };
  return bNumber.toFormat(decimals, (options == null ? void 0 : options.round) ?? BigNumber.ROUND_DOWN, fmt) + suffix;
}
function fAmount(number, options) {
  return fNumber(number, {
    ...options,
    round: (options == null ? void 0 : options.round) ?? BigNumber.ROUND_DOWN,
    decimals: (options == null ? void 0 : options.decimals) ?? 2
  });
}
const numberOrZero = (input) => {
  switch (typeof input) {
    case "number":
      return input;
    default:
      return isNumber(input) ? Number(input) : 0;
  }
};
const isNumber = (input) => {
  return !isNaN(input) && isFinite(input);
};
const parseBN = (input, defaultValue) => {
  if (!input && input !== 0) return defaultValue;
  if (typeof input === "string") input = input.trim().replace(`/${EN_GROUP_SEPARATOR}/g`, "");
  const result = BigNumber.isBigNumber(input) ? input : new BigNumber(input);
  if (!result.isFinite() || result.isNaN()) return defaultValue;
  return result;
};
const bnOrZero = (input, defaultValue = BN_ZERO) => {
  return parseBN(input, defaultValue);
};
const getDefaultLocale = () => {
  return (navigator == null ? void 0 : navigator.language) || "en-US";
};
const EXAMPLE_NUMBER = 1000.5;
const getSeparators = (locale = getDefaultLocale()) => {
  const parts = new Intl.NumberFormat(locale).formatToParts(EXAMPLE_NUMBER);
  let groupSeparator = "";
  let decimalSeparator = "";
  for (const part of parts) {
    if (part.type === "group") {
      groupSeparator = part.value;
    } else if (part.type === "decimal") {
      decimalSeparator = part.value;
    }
  }
  return { groupSeparator, decimalSeparator };
};
const standardizeNumber = (number) => {
  const trimmedNumber = number.trim();
  const { groupSeparator, decimalSeparator } = getSeparators();
  if (groupSeparator === EN_GROUP_SEPARATOR) return trimmedNumber;
  const cleanedNumber = trimmedNumber.replace(new RegExp(`\\${groupSeparator}`, "g"), "");
  return cleanedNumber.replace(decimalSeparator, EN_DECIMAL_SEPARATOR);
};
export {
  bnOrZero,
  fAmount,
  fNumber,
  getSeparators,
  isNumber,
  numberOrZero,
  parseBN,
  standardizeNumber
};
